{
  "api_settings_page": {
    "header": {
      "title": "API",
      "description": "The SparkLayer API lets you connect your backend system to send B2B data.",
      "footer": "Learn more about the SparkLayer API",
      "actions": {
        "create": "Create new API key"
      }
    },
    "table": {
      "headings": {
        "name": "Name",
        "client_id": "Client ID",
        "created": "Created"
      },
      "caption": "Table of all your API keys",
      "empty": {
        "title": "No API keys yet",
        "body": "Create an API key to start connecting your backend system to the SparkLayer API."
      }
    },
    "docs": {
      "header": "Integrating with the SparkLayer API",
      "body": "Once you've created your API key, you're ready to begin integrating with the SparkLayer API to start sending data. Or invite your technical partner to your account to get you going with your integration needs.",
      "buttons": {
        "docs": "SparkLayer API docs",
        "invite": "Invite team members"
      }
    },
    "notifications": {
      "errors": {
        "create_failed": "Something went wrong while creating this API key.",
        "delete_failed": "Something went wrong while deleting this API key."
      }
    }
  }
}
